<div class="font-poppins">
  <nz-card *ngIf="!newsletterFormVisible">
    <div class="row m-b-30 d">
      <div class="col-lg-7">
        <div class="d-md-flex">
          <div *ngIf="iconVisible" class="m-b-10 m-r-20">
            <button
              title="Go Back"
              (click)="closeDetail()"
              nz-button
              nzType="default"
            >
              <i nz-icon nzType="arrow-left" nzTheme="outline"></i>
            </button>
          </div>
          <div class="m-b-10 m-r-20">
            <nz-input-group [nzPrefix]="prefixTemplate" [nzSuffix]="suffixTemplate">
              <input
                type="text"
                nz-input
                placeholder="Search"
                (keyup)="onKeyUp(searchBox.value)"
                [(ngModel)]="searchTerm"
                #searchBox
              />
            </nz-input-group>
            <ng-template #suffixTemplate>
              <a nz-icon class="opacity-05" (click)="resetSearch()">
                <i nz-icon nzType="close" class="opacity-05"></i>
              </a>
            </ng-template>
            <ng-template #prefixTemplate>
              <i nz-icon nzType="search" class="opacity-05"></i>
            </ng-template>
          </div>
          <div class="m-b-10 m-r-10">
            <button
            nz-button
            nz-popover
            [nzPopoverContent]="popoverContent"
            nzPopoverTrigger="click"
            nzPopoverPlacement="bottom"
            [(nzPopoverVisible)]="filterVisible"
            (nzPopoverVisibleChange)="onPopoverVisibleChange($event)"
            class="btn-outline resource-btn"
            style="text-align: center"
          >
         
              <span *ngIf="!this.isArchived">All Newsletters</span>
             <span *ngIf="this.isArchived">Archived</span>
              <i
                nz-icon
                nzType="caret-down"
                style="position: relative; top: 1px; left: -3px"
                nzTheme="outline"
              ></i>
            </button>
            <ng-template
              class="filter"
              style="text-align: left; padding: 0px !important"
              #popoverContent
            >
              <div class="">
                <div nz-row nzGutter="24" style="padding-top: 10px;">
                  <div
                    nz-col
                    class="gutter-row"
                    nzSpan="24"
                    style="padding-bottom: 15px"
                  >
                    <span class="filter-heading">Show Newsletters that are</span>
                  </div>
                </div>
              </div>
              <div style="height: 40px" nz-row>
                <div
                  style="color: #2d2d35; font-family: Poppins !important"
                  nz-col
                  nzSpan="24"
                >
                  <label nz-checkbox [(ngModel)]="archived">Archived</label>
                </div>
              </div>
              <div nz-row>
                <div
                  nz-col
                  nzSpan="24"
                  class="d-flex align-items-center justify-content-between"
                >
                  <span (click)="clickFilter()" class="cancel-label"
                    >Cancel</span
                  >
                  <button
                    class="btn-fill"
                    nz-button
                    nzType="default"
                    nzSize="small"
                    (click)="applyFilters()"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="col-lg-5">
        <div class="d-md-flex justify-content-end">
          <button
            nz-button=""
            nztype=" primary"
            class="font-small-caps btn-custom-light"
            title="Delete"
            *ngIf="anyChecked"
            nz-wave="[object Object]"
            nz-popconfirm
            nzPopconfirmTitle="Are you sure you want to delete the selected newsletters?"
            (nzOnConfirm)="deleteNewsletter(null, true)"
            nzPopconfirmPlacement="topRight"
            style="margin-right: 10px"
            [nzLoading]="isLoading"
          >
            <i class="font-size-16" nz-icon nzType="delete" theme="fill"></i>
          </button>
          <button
            nz-button
            nzType="default"
            class="btn-fill"
            (click)="openNewsletterForm()"
          >
            <span>
              <i
                class="fa fa-plus button-plus-icon"
                aria-hidden="true"
              ></i></span
            >&nbsp;NEW
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div>
        <div>
          <nz-table
            #newsletterListTable
            [nzData]="newsletterData"
            [nzPageSize]="20"
            [nzLoading]="showLoad"
          >
            <thead>
              <tr>
                <th
                  nzShowCheckbox
                  [(nzChecked)]="allChecked"
                  (nzCheckedChange)="checkAll($event)"
                  [nzDisabled]="this.isArchived"

                ></th>
                <ng-container *ngFor="let column of listOfColumns">
                  <th
                    *ngIf="column.name !== ''"
                    [hidden]="column.name === 'Actions' && this.isArchived"
                    [nzSortOrder]="column.sortOrder"
                    [nzSortFn]="column.sortFn"
                    [nzSortDirections]="column.sortDirections"
                    [nzFilterMultiple]="column.filterMultiple"
                    [nzWidth]="column.colWidth"
                  >
                    {{ column.name }}
                  </th>
                  <th *ngIf="column.name === ''">{{ column.name }}</th>
                </ng-container>
              </tr>
            </thead>
            <tbody  [@fadeIn]>
              <tr
                *ngFor="let data of newsletterListTable.data"
                class="data-row cursor-move"
                [ngStyle]="{'opacity': this.isArchived ? '0.7' : '1'}"
                
              >
                <ng-container>
                  <td
                    nzShowCheckbox
                    [(nzChecked)]="data.checked"
                    (nzCheckedChange)="refreshStatus()"
                    [nzDisabled]="this.isArchived"

                  ></td>

                  <td
                  (click)="fillNewsletterForm(data)"
                  >
                    <div class="d-flex align-items-center">
                      <span class="m-b-0">{{ data.title }}</span>
                    </div>
                  </td>
                  <td (click)="fillNewsletterForm(data)">
                    <span class="text-truncate" [title]="data.description || ''">{{ data.description || '—' }}</span>
                  </td>
                  <td
                  (click)="fillNewsletterForm(data)"
                  title="{{ data.banner_color || '#F1EDEB' }}"
                  >
                    <div
                      [style.background-color]="data.banner_color || '#F1EDEB'"
                      class="color-swatch"
                    ></div>
                  </td>
                  <td
                  (click)="fillNewsletterForm(data)"
                  title="{{ data.text_color || '#000000' }}"
                  >
                    <div
                      [style.background-color]="data.text_color || '#000000'"
                      class="color-swatch"
                    ></div>
                  </td>
                  <td
                  (click)="fillNewsletterForm(data)"
                  >
                    <span>{{ data.created | date: 'MM/dd/yyyy' }}</span>
                  </td>

                  <td *ngIf="!this.isArchived">
                    <span class="data-row-action">
                      <a
                        class="m-r-5"
                        nz-button
                        nzType="default"
                        nzShape="circle"
                        nz-tooltip
                        nzTooltipTitle="Edit"
                        (click)="$event.stopPropagation(); fillNewsletterForm(data)"
                      >
                        <i
                          nz-icon
                          nzType="edit"
                          theme="outline"
                        ></i>
                      </a>
                      <button
                        nz-button
                        nzType="default"
                        nzShape="circle"
                        nz-tooltip
                        nzTooltipTitle="Delete"
                        (click)="$event.stopPropagation()"
                      >
                        <i
                          nz-icon
                          nzType="delete"
                          theme="outline"
                          nz-popconfirm
                          nzPopconfirmTitle="Are you sure you want to delete this newsletter?"
                          (nzOnConfirm)="deleteNewsletter(data.newsletter_id)"
                        ></i>
                      </button>
                    </span>
                     
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </div>
    </div>
  </nz-card>

  <nz-card
    id="createNewsletter"
    *ngIf="newsletterFormVisible"
    class="margin-bottom: 0px"
  >
    <div nz-row nzGutter="16"></div>
    <div>
      <div nz-row>
    <nz-spin nzTip="Please wait..." [nzSpinning]="isLoading">    
        <div nz-col nzSpan="24">
          <div class="m-t-30">
            <form
              nz-form
              nzLayout="vertical"
              class=""
              [formGroup]="newsletterForm"
            >
              <div nz-row>
                <div nz-col nzSpan="24">
                  <nz-form-item>
                    <nz-form-label nzRequired>Title</nz-form-label>
                    <nz-form-control>
                      <nz-form-control
                        class="ng-tns-c16-67 ant-form-item-control-wrapper ng-star-inserted ant-col-24"
                      >
                        <div class="ant-form-item-control">
                          <span class="ant-form-item-children">
                            <input
                              nz-input=""
                              placeholder="Newsletter Title"
                              formControlName="title"
                              nzSize="medium"
                              class="ant-input ng-untouched ng-pristine ng-invalid" required/><span
                              class="ant-form-item-children-icon"
                            >
                          </span>
                            <span class="text-danger" *ngIf="newsletterForm.get('title')?.errors?.['required'] && newsletterForm.get('title')?.touched">This field is required.</span>
                          </span>
                        </div>
                      </nz-form-control>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
              <div nz-row>
                <div nz-col nzSpan="24">
                  <nz-form-item>
                    <nz-form-label nzRequired>Description</nz-form-label>
                    <nz-form-control>
                      <input
                        nz-input
                        formControlName="description"
                        placeholder="Newsletter card description"
                        nzSize="medium"
                      />
                      <span class="text-danger" *ngIf="newsletterForm.get('description')?.errors?.['required'] && newsletterForm.get('description')?.touched">This field is required.</span>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
              <div nz-row>
                <div nz-col nzSpan="24">
                  <nz-form-item>
                    <nz-form-label nzRequired>Content</nz-form-label>
                    <nz-form-control>
                      <quill-editor
                        [modules]="modules"
                        formControlName="content"
                        [styles]="{'min-height': '300px'}"
                      ></quill-editor>
                    </nz-form-control>
                    <span class="text-danger" *ngIf="newsletterForm.get('content')?.errors?.['required'] && newsletterForm.get('content')?.touched">This field is required.</span>
                  </nz-form-item>
                </div>
              </div>

              <div nz-row>
                <div nz-col nzSpan="24">
                  <nz-form-item>
                    <nz-form-label>Banner Color</nz-form-label>
                    <nz-form-control>
                      <div class="d-flex align-items-center">
                        <input
                          type="color"
                          formControlName="banner_color"
                          style="width: 60px; height: 32px; border: 1px solid #d9d9d9; border-radius: 4px; cursor: pointer;"
                        />
                        <span class="m-l-10">{{ newsletterForm.get('banner_color')?.value || '#F1EDEB' }}</span>
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div nz-row>
                <div nz-col nzSpan="24">
                  <nz-form-item>
                    <nz-form-label>
                      Text Color
                      <i
                        nz-icon
                        nzType="info-circle"
                        nzTheme="outline"
                        class="m-l-5 text-muted"
                        style="cursor: help; font-size: 14px; vertical-align: middle;"
                        nz-tooltip
                        nzTooltipTitle="This applies to the card title and card description on the app."
                      ></i>
                    </nz-form-label>
                    <nz-form-control>
                      <div class="d-flex align-items-center">
                        <input
                          type="color"
                          formControlName="text_color"
                          style="width: 60px; height: 32px; border: 1px solid #d9d9d9; border-radius: 4px; cursor: pointer;"
                        />
                        <span class="m-l-10">{{ newsletterForm.get('text_color')?.value || '#000000' }}</span>
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

            </form>
          </div>
        </div>
        </nz-spin>
        <div nz-col nzSpan="24">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            "
          >
            <div nz-col nzSpan="12">
              <button
                *ngIf="!updateMode"
                (click)="resetNewsletterForm()"
                nz-button=""
                nztype="default"
                class="ant-btn ant-btn-default"
                nz-wave="[object Object]"
              >
                <span>Reset</span>
              </button>
              <button
                *ngIf="updateMode"
                (click)="resetUpdateForm()"
                nz-button=""
                nztype="default"
                class="ant-btn ant-btn-default"
                nz-wave="[object Object]"
              >
                <span>Reset</span>
              </button>
            </div>

            <div nz-col nzSpan="12" style="text-align: right">
              <button
                nz-button=""
                nztype="default"
                class="cancelbtn-outline"
                (click)="this.checkFormState()"
              >
                <span>Cancel</span>
              </button>
              <button
                nz-button=""
                nztype="default"
                *ngIf="!updateMode"
                class="ant-btn ant-btn-primary m-l-10"
                style="padding-left: 25px; padding-right: 25px"
                (click)="submitNewsletter()"
                [nzLoading]="isLoading"
                [disabled]="!this.newsletterForm.valid"
              >
                <span>Save</span>
              </button>

              <button
                nz-button=""
                nztype="default"
                *ngIf="updateMode"
                class="ant-btn ant-btn-primary m-l-10"
                style="padding-left: 25px; padding-right: 25px"
                [nzLoading]="isLoading"
                (click)="updateNewsletter()"
                [disabled]="!this.newsletterForm.valid || !newsletterForm.dirty"
              >
                <span>Update</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nz-card>
</div>

